import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../../guards/authenticated.guard';
import { ReportPreviewPageComponent } from './preview.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: ReportPreviewPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class PreviewPageRoutingModule {}
